<template>
	<div class="home" >
		<div class="container p-l-r-0 container-shadow">
			<div class="row">
				<UserProfile :nameUpdate="nameToheader"></UserProfile>
			</div>
			<div class="row content-holder">
				<div class="col-sm-3 col-md-3 col-xs-3 dashboard-sec-left" >
					<div class="col text-left" style="padding-top:20px;">
						<a href="javascript://" @click="$router.go(-1)" class="btn btn btn-primary-inverse btn-secondary"> Back</a>
					</div>
					<div class="col dashboard-left-menu ">
						<ul>
							<li>
								<a href="javascript://"  @click="changeSection('personal')" v-bind:class="{active:isProfile}"><span class="text">Personal Information</span> </a>
							</li>
							<li>
								<a href="javascript://" @click="changeSection('billing')" v-bind:class="{active:isBilling}"><span class="text">Billing Information</span></a>
							</li>
							<li>
								<a href="/tour" @click="changeSection('tour')" v-bind:class="{active:isBilling}"><span class="text">Dashboard Tour</span></a>
							</li>
						</ul>
					</div>
				</div>
				<div class="col-sm-9 col-md-9 col-xs-9 dashboard-sec-right user-profile" >
					<personal v-if="isProfile" @NameUpdate="updateName"></personal>
					<billing v-if="isBilling"></billing>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
// @ is an alias to /src
import UserProfile from "../layouts/profile-header.vue"
import personal from "../../components/personal_info.vue"
import billing from "../../components/billing_info.vue"

import { mapGetters } from 'vuex'
export default {
	name: 'user_profile',
	data(){
		return {
		list:{},
			isProfile: true,
			isBilling: false,
			connectionStatus:'',
			nameToheader:''
		}
		
	},
	components: {
		UserProfile,
		personal,
		billing
	},
	computed:{
		...mapGetters('user', {
			userList: 'list',
		})
	},
	methods:{
		changeSection(data){
			if(data=='personal'){
				this.isProfile = true;
				this.isBilling = false;
			}else if(data=='billing'){
				this.isProfile = false;
				this.isBilling = true;
			}
		},
		myFunction: function () {	
		if(navigator.onLine){
		this.connectionStatus = "Connected to internet.";
		}else{
		this.connectionStatus = "Unable to connect to internet.";	
		}
    },
	updateName(playload){
		this.nameToheader=playload.name;
	}
	},
	created(){
	}
};
</script>
